var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2761_8)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2761_8",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 0H0V20H20V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2761_8)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10ZM10.3583 7.38244C9.38575 7.787 7.44179 8.62433 4.52659 9.89442C4.05321 10.0827 3.80523 10.2668 3.78266 10.4469C3.7445 10.7512 4.12561 10.8711 4.64458 11.0342C4.71517 11.0565 4.78832 11.0795 4.8633 11.1038C5.37388 11.2698 6.0607 11.464 6.41776 11.4717C6.74163 11.4787 7.10312 11.3452 7.50222 11.0711C10.226 9.2325 11.632 8.30317 11.7202 8.28314C11.7826 8.26901 11.8688 8.25123 11.9273 8.30321C11.9858 8.35517 11.9801 8.45358 11.9738 8.48C11.9361 8.64092 10.4401 10.0317 9.66592 10.7515C9.42458 10.9758 9.25342 11.135 9.21842 11.1713C9.14 11.2528 9.06008 11.3298 8.98333 11.4038C8.509 11.8611 8.15328 12.204 9.003 12.764C9.41142 13.0331 9.73817 13.2556 10.0642 13.4776C10.4202 13.7201 10.7752 13.9619 11.2347 14.2631C11.3517 14.3398 11.4635 14.4195 11.5724 14.4971C11.9867 14.7925 12.359 15.0578 12.8188 15.0155C13.0861 14.9909 13.3621 14.7397 13.5022 13.9903C13.8335 12.2193 14.4847 8.38208 14.6352 6.80082C14.6484 6.66228 14.6318 6.48497 14.6185 6.40715C14.6052 6.32932 14.5773 6.21842 14.4762 6.13633C14.3563 6.03912 14.1714 6.01862 14.0887 6.02007C13.7125 6.0267 13.1355 6.22735 10.3583 7.38244Z",
    fill: "#6130B5"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2761_8"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.ee8792498741863d9e9058cc0ba09f0c.svg";
export { ForwardRef as ReactComponent };